export const categories = [
  { slug: "guide", name: "使用指南", icon: "ri-guide-line", description: "快速上手91叔叔的完整教程与技巧" },
  { slug: "resource", name: "资源推荐", icon: "ri-stack-line", description: "精选优质资源，发现更多精彩内容" },
  { slug: "member", name: "会员专区", icon: "ri-vip-crown-line", description: "会员专属功能与权益详解" },
  { slug: "news", name: "最新动态", icon: "ri-flashlight-line", description: "平台最新资讯与功能更新" },
  { slug: "tips", name: "实用技巧", icon: "ri-lightbulb-line", description: "使用小窍门与隐藏功能揭秘" },
  { slug: "community", name: "社区互动", icon: "ri-group-line", description: "用户交流、经验分享与活动" },
];

export const articles = [
  {
    id: 1,
    title: "91叔叔平台完整使用教程：从注册到精通",
    excerpt: "无论你是新用户还是老用户，这篇完整教程将带你从零开始掌握91叔叔的所有核心功能，包括账号注册、内容浏览、资源下载和会员权益激活，让你充分享受平台带来的便利与乐趣。",
    category: "guide",
    image: "https://readdy.ai/api/search-image?query=Modern%20workspace%20with%20laptop%20displaying%20content%20platform%20interface%2C%20warm%20ambient%20lighting%2C%20cozy%20home%20office%20setting%20with%20plants%20and%20coffee%2C%20clean%20minimalist%20design%2C%20soft%20shadows%2C%20editorial%20photography%20style%20with%20warm%20neutral%20tones&width=800&height=500&seq=article-01&orientation=landscape",
    date: "2026-07-28",
    readTime: "8分钟",
    featured: true,
    content: `91叔叔作为一个深受用户喜爱的内容平台，提供了丰富的功能和优质的服务。本文将为你详细介绍如何使用91叔叔的每一项功能。

## 一、账号注册与登录

首先，你需要通过官方网站入口访问91叔叔平台。点击首页右上角的"注册"按钮，填写基本信息即可完成注册。注册过程简单快捷，只需提供邮箱地址和设置密码即可。

如果你已经拥有账号，直接点击"登录"按钮，输入邮箱和密码即可进入平台。

## 二、平台界面概览

登录后，你会看到清晰直观的界面布局：
- 顶部导航栏：包含首页、分类浏览、资源推荐、会员专区等主要入口
- 中间内容区：展示最新推荐文章和热门内容
- 侧边栏：快速访问收藏夹和历史记录
- 底部信息栏：关于我们、联系方式等

## 三、浏览与搜索内容

91叔叔拥有海量的优质内容资源。你可以通过以下方式找到感兴趣的内容：
1. 分类浏览：按内容类型进行筛选
2. 关键词搜索：在搜索框中输入关键词
3. 热门推荐：查看平台推荐的热门内容

## 四、会员功能详解

成为91叔叔会员后，你将享受以下专属权益：
- 无广告浏览体验
- 优先访问最新内容
- 专属资源下载权限
- 会员专属客服通道

## 五、常见问题解答

如果在使用过程中遇到任何问题，可以查看帮助中心或联系在线客服。我们的客服团队会在24小时内回复你的问题。`,
  },
  {
    id: 2,
    title: "91叔叔最新资源推荐：2026年8月不可错过的内容",
    excerpt: "91叔叔平台每月都会更新大量优质资源。本文为你精选了2026年8月最值得关注的内容，涵盖多个热门分类，助你高效获取最有价值的信息，不错过任何精彩。",
    category: "resource",
    image: "https://readdy.ai/api/search-image?query=Curated%20digital%20content%20collection%20displayed%20on%20tablet%20and%20phone%20screens%2C%20warm%20ambient%20lighting%2C%20modern%20minimalist%20desk%20setup%2C%20clean%20aesthetic%2C%20editorial%20product%20photography%20with%20soft%20shadows%20and%20neutral%20background&width=800&height=500&seq=article-02&orientation=landscape",
    date: "2026-08-01",
    readTime: "6分钟",
    featured: true,
    content: `2026年8月，91叔叔平台迎来了大量优质内容的更新。我们的编辑团队精心筛选了本月最值得关注的资源，希望这些推荐能帮助你发现更多精彩。

## 本月热门推荐

### 精选内容一：深度使用指南系列

本月我们推出了全新的深度使用指南系列，涵盖平台各个功能模块的详细解析。无论你是新手还是老用户，都能从中获得实用的操作技巧。

### 精选内容二：独家资源合集

编辑团队整理了近期最受欢迎的资源合集，包含多个热门分类。这些资源经过严格筛选，确保每一份都能为用户带来实际价值。

### 精选内容三：会员专属福利

本月会员专区新增了多项专属福利，包括优先体验新功能、专属下载权限等。如果你还不是会员，现在正是加入的好时机。

## 资源分类导航

91叔叔的资源分类涵盖了以下主要领域：
- 实用工具与软件推荐
- 学习资料与教程
- 娱乐内容与休闲资源
- 行业资讯与动态

## 如何使用推荐资源

每项推荐资源都附有详细的使用说明和注意事项。点击任意推荐即可查看完整内容，部分资源支持直接下载或收藏。

## 持续关注

平台资源每周更新，建议你将91叔叔加入收藏夹，或关注我们的官方渠道，第一时间获取最新推荐。`,
  },
  {
    id: 3,
    title: "91叔叔会员功能全解析：值不值得开通？",
    excerpt: "91叔叔会员到底有哪些功能？开通会员后能享受哪些权益？本文为你详细解析91叔叔会员的全部功能，帮你判断是否值得开通，做出最明智的选择。",
    category: "member",
    image: "https://readdy.ai/api/search-image?query=Premium%20membership%20golden%20card%20on%20elegant%20desk%20with%20warm%20lighting%2C%20luxury%20lifestyle%20aesthetic%2C%20minimalist%20composition%2C%20soft%20gold%20and%20cream%20tones%2C%20editorial%20photography%20with%20refined%20shadows&width=800&height=500&seq=article-03&orientation=landscape",
    date: "2026-07-25",
    readTime: "7分钟",
    featured: true,
    content: `很多用户都在问：91叔叔会员到底值不值得开通？今天我们就来详细解析会员的全部功能，帮助你做出最合适的选择。

## 会员权益一览

### 1. 无广告纯净体验
会员用户在使用平台时将不会看到任何广告内容，获得最纯粹的浏览体验。页面加载速度更快，内容展示更加流畅。

### 2. 优先访问权限
会员用户可以在内容公开发布前提前24小时访问最新资源。这意味着你永远比普通用户先一步获得精彩内容。

### 3. 专属资源库
会员专区拥有大量仅限会员访问的优质资源。这些资源经过严格筛选和精心制作，内容质量更高，实用性更强。

### 4. 高速下载通道
会员用户享受专属的高速下载通道，下载速度比普通用户快3倍以上，大文件也能快速完成下载。

### 5. 收藏与历史同步
会员账号支持跨设备同步收藏夹和浏览历史，无论你在哪个设备上使用，都能无缝衔接。

## 会员定价方案

91叔叔提供多种会员方案，满足不同用户的需求：
- 月度会员：适合短期使用或试用
- 季度会员：性价比较高
- 年度会员：最划算的选择

## 适合开通会员的用户类型

以下类型的用户最适合开通91叔叔会员：
- 经常使用平台的活跃用户
- 需要大量资源的重度使用者
- 追求最佳体验的品质用户
- 不想被广告打扰的用户

## 总结

如果你经常使用91叔叔平台，并且重视使用体验和内容质量，那么开通会员绝对物超所值。建议可以先尝试月度会员，体验后再决定是否升级为更长期的方案。`,
  },
  {
    id: 4,
    title: "91叔叔2026年8月功能更新公告",
    excerpt: "91叔叔平台在2026年8月进行了多项重要功能更新，包括界面优化、搜索增强、会员权益升级等。本文为您详细解读本次更新的全部内容。",
    category: "news",
    image: "https://readdy.ai/api/search-image?query=Digital%20update%20and%20innovation%20concept%20with%20floating%20interface%20elements%2C%20warm%20gradient%20background%2C%20modern%20tech%20aesthetic%2C%20clean%20and%20minimal%20design%2C%20soft%20glowing%20accents%2C%20editorial%20style&width=800&height=500&seq=article-04&orientation=landscape",
    date: "2026-08-03",
    readTime: "5分钟",
    featured: false,
    content: `91叔叔平台在2026年8月进行了重要的功能更新，我们持续倾听用户反馈，不断优化产品体验。以下是本次更新的详细内容。

## 界面优化

本次更新对平台整体界面进行了全面优化：
- 首页布局更加清晰，内容展示更加直观
- 导航菜单重新设计，分类访问更加便捷
- 移动端体验大幅提升，适配更多设备

## 搜索功能增强

搜索是用户最常用的功能之一，本次更新我们对搜索进行了以下改进：
- 搜索速度提升50%
- 搜索结果更加精准
- 新增搜索历史与热门搜索推荐

## 会员权益升级

会员专区新增多项功能：
- 新增个人数据看板
- 收藏夹容量扩容至原来的2倍
- 新增夜间阅读模式

## 其他优化

- 修复了若干已知问题
- 整体性能提升，页面加载更快
- 安全性能增强，账号保护更加完善

## 未来计划

我们正在开发以下新功能，敬请期待：
- 社区互动功能升级
- 个性化内容推荐算法优化
- 更多语言版本支持`,
  },
  {
    id: 5,
    title: "91叔叔隐藏功能揭秘：99%用户不知道的实用技巧",
    excerpt: "91叔叔平台隐藏着许多不为人知的实用功能。本文为你揭秘这些隐藏技巧，帮助你更高效地使用平台，解锁更多玩法，成为91叔叔的高级用户。",
    category: "tips",
    image: "https://readdy.ai/api/search-image?query=Hidden%20features%20and%20secret%20tips%20concept%20with%20magnifying%20glass%20over%20digital%20interface%2C%20warm%20ambient%20lighting%2C%20mysterious%20yet%20inviting%20atmosphere%2C%20minimalist%20composition%2C%20editorial%20photography%20with%20warm%20neutral%20tones&width=800&height=500&seq=article-05&orientation=landscape",
    date: "2026-07-20",
    readTime: "6分钟",
    featured: false,
    content: `91叔叔平台有很多隐藏功能，即使长期用户也不一定全部了解。今天我们就来揭秘这些实用技巧，让你更高效地使用平台。

## 快捷键大全

91叔叔支持以下键盘快捷键：
- Ctrl + F：快速搜索
- Ctrl + D：添加到收藏夹
- Ctrl + B：返回上一页
- Esc：关闭弹窗

## 阅读模式切换

在文章页面，你可以通过点击右上角的阅读模式按钮，切换为专注阅读模式。该模式下会隐藏所有干扰元素，让你全身心投入阅读。

## 批量收藏与下载

在搜索结果或分类列表中，你可以勾选多个内容，然后使用批量操作功能一次性收藏或下载。这个功能可以大幅提升效率。

## 自定义首页

你可以在设置中自定义首页显示的内容类型。只选择你感兴趣的分类，首页将只展示相关内容，减少信息干扰。

## 离线阅读

对于移动端用户，你可以提前将文章缓存到本地，在没有网络的情况下也能正常阅读。这个功能在地铁、飞机等场景中特别实用。

## 内容提醒

你可以为特定分类或关键词设置内容提醒。当有新内容发布时，你将第一时间收到通知，不错过任何重要更新。

## 数据导出

会员用户可以将自己的收藏列表、浏览历史等数据导出为文件，方便备份或迁移到其他设备。

希望这些隐藏技巧能帮助你更好地使用91叔叔平台！`,
  },
  {
    id: 6,
    title: "91叔叔社区互动指南：如何获得最佳交流体验",
    excerpt: "91叔叔社区是用户交流的核心场所。本文为你介绍社区的各项互动功能、交流规范以及如何最大化利用社区资源，结识志同道合的朋友。",
    category: "community",
    image: "https://readdy.ai/api/search-image?query=Online%20community%20interaction%20concept%20with%20connected%20people%20through%20digital%20devices%2C%20warm%20friendly%20atmosphere%2C%20modern%20minimalist%20style%2C%20soft%20natural%20lighting%2C%20editorial%20photography%20with%20warm%20tones&width=800&height=500&seq=article-06&orientation=landscape",
    date: "2026-07-18",
    readTime: "5分钟",
    featured: false,
    content: `91叔叔不仅是一个内容平台，更是一个充满活力的社区。在这里，你可以与其他用户交流心得、分享经验、参与活动。本文将介绍社区的各项功能与使用技巧。

## 社区功能概览

91叔叔社区提供以下互动功能：
- 评论区交流：在文章下方发表评论，与其他读者讨论
- 话题广场：参与热门话题讨论
- 私信功能：与其他用户一对一交流
- 活动中心：参与平台举办的各类活动

## 评论规范与礼仪

为了维护良好的社区氛围，请遵守以下规范：
- 尊重他人，文明交流
- 禁止发布广告和垃圾信息
- 鼓励建设性讨论和有价值的分享
- 发现违规内容请及时举报

## 如何发布优质评论

优质评论通常具备以下特征：
- 内容与主题相关，言之有物
- 提供独特的观点或补充信息
- 语言清晰，表达准确
- 友善礼貌，促进交流

## 参与社区活动

平台定期举办各类社区活动，包括：
- 主题征文活动
- 资源分享活动
- 投票与评选活动
- 线上交流会

## 积分与等级体系

活跃参与社区互动可以积累积分，提升用户等级。高等级用户将获得更多特权和认可。

快来加入91叔叔社区，结识更多志同道合的朋友吧！`,
  },
  {
    id: 7,
    title: "91叔叔安全使用指南：保护你的账号与隐私",
    excerpt: "网络安全不容忽视。本文为你详细介绍91叔叔平台的安全功能设置、账号保护措施以及隐私管理技巧，帮助你安全放心地使用平台。",
    category: "guide",
    image: "https://readdy.ai/api/search-image?query=Digital%20security%20and%20privacy%20protection%20concept%20with%20shield%20icon%20on%20screen%2C%20warm%20ambient%20lighting%2C%20minimalist%20workspace%2C%20clean%20and%20safe%20aesthetic%2C%20editorial%20photography%20with%20soft%20shadows&width=800&height=500&seq=article-07&orientation=landscape",
    date: "2026-07-15",
    readTime: "6分钟",
    featured: false,
    content: `在享受91叔叔平台带来的便利时，账号安全和个人隐私保护同样重要。本文将详细介绍平台的各项安全功能和最佳实践。

## 账号安全基础设置

### 强密码设置
建议使用包含大小写字母、数字和特殊字符的强密码，长度不少于8位。避免使用生日、手机号等容易被猜测的信息。

### 双重验证
开启双重验证可以为你的账号增加一层额外的保护。即使密码泄露，攻击者也无法登录你的账号。

### 登录提醒
开启登录提醒功能后，每当有新设备登录你的账号，你都会收到通知，及时发现异常登录行为。

## 隐私设置指南

91叔叔提供以下隐私管理功能：
- 个人资料可见性设置
- 浏览历史隐私模式
- 收藏夹公开/私密切换
- 评论匿名发布选项

## 防范常见安全威胁

### 钓鱼攻击防范
请认准91叔叔官方域名，不要点击来源不明的链接。官方永远不会通过邮件或私信索要你的密码。

### 公共设备使用建议
在公共电脑或他人设备上使用时，请务必在使用完毕后退出登录，并清除浏览器缓存。

## 紧急情况处理

如果你怀疑账号被盗用，请立即：
1. 修改密码
2. 检查并撤销可疑设备的登录权限
3. 联系官方客服

安全使用91叔叔，让你的体验更加安心愉快！`,
  },
  {
    id: 8,
    title: "91叔叔平台对比评测：为什么选择我们？",
    excerpt: "市面上内容平台众多，91叔叔有何独特优势？本文从功能、内容质量、用户体验、会员价值等多个维度进行客观对比，帮你了解91叔叔的核心竞争力。",
    category: "resource",
    image: "https://readdy.ai/api/search-image?query=Comparison%20and%20evaluation%20concept%20with%20two%20digital%20devices%20side%20by%20side%2C%20warm%20ambient%20lighting%2C%20modern%20minimalist%20desk%2C%20clean%20aesthetic%2C%20editorial%20photography%20with%20neutral%20background&width=800&height=500&seq=article-08&orientation=landscape",
    date: "2026-07-10",
    readTime: "7分钟",
    featured: false,
    content: `面对众多内容平台，91叔叔凭借独特的优势脱颖而出。本文将从多个维度进行客观分析，帮助你了解为什么越来越多的用户选择91叔叔。

## 内容质量对比

91叔叔的内容经过严格的审核流程，确保每篇内容都具有实用价值。我们的编辑团队由经验丰富的专业人士组成，对内容质量严格把关。

## 用户体验对比

91叔叔的界面设计简洁直观，操作流程清晰流畅。无论是新用户还是老用户，都能快速上手使用。平台还支持多设备无缝切换，让你随时随地访问内容。

## 会员价值对比

与其他平台相比，91叔叔的会员方案提供了更高的性价比。我们不仅提供无广告体验和优先访问权限，还有丰富的会员专属内容和专属客服支持。

## 社区氛围对比

91叔叔拥有活跃友好的社区氛围。用户之间的互动积极正面，形成了良好的知识分享和交流环境。

## 技术创新

我们持续投入技术研发，不断提升平台性能和用户体验。最近的更新包括搜索算法优化、个性化推荐系统升级等。

## 用户口碑

根据用户反馈，91叔叔在以下方面获得高度评价：
- 内容丰富度：★★★★★
- 使用便捷性：★★★★★
- 会员性价比：★★★★☆
- 客服响应速度：★★★★★

选择91叔叔，就是选择更优质的内容体验！`,
  },
];